import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EMPTY, from } from 'rxjs';
import { ClientVendorSearchModel } from 'src/app/classes/client-vendor-search-model';
import { CompanyService } from 'src/app/services/company.service';
import { GoogleService } from 'src/app/services/google.service';
import { ToastService } from 'src/app/services/toast.service';
import { companiesService } from 'src/app/shared/vive-api/companies.service';

@Component({
  selector: 'app-vendor-search-container',
  templateUrl: './vendor-search-container.component.html',
  styleUrls: ['./vendor-search-container.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class VendorSearchContainerComponent {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private ToastService: ToastService,
    private CompanyService: CompanyService,
    private GoogleService: GoogleService,
    private ChangeDetectorRef: ChangeDetectorRef
  ) {
    this.route.paramMap.subscribe({
      next: (ParamMap) => {
        const view = ParamMap.get('view');
        const CompanyId = Number(ParamMap.get('CompanyId'));

        if (!view || !['vive', 'client'].includes(view)) {
          throw this.ToastService.addErrorToast(
            'Error',
            'Invalid view information.',
            { returnError: true }
          );
        }

        if (!CompanyId) {
          throw this.ToastService.addErrorToast('Error', 'Missing Client Id.', {
            returnError: true
          });
        }

        Object.assign(this, { view, CompanyId });

        from(
          companiesService.findOneById({
            pathParams: {
              companyId: CompanyId
            }
          })
        ).subscribe({
          next: (Company) => {
            const { legalName } = Company;

            if (!legalName) {
              throw this.ToastService.addErrorToast(
                'Error',
                'Client is missing legal name.',
                { returnError: true }
              );
            }

            this.ViewToTextMap = {
              vive: {
                title: 'Potential Vendor Search',
                helperText: `Search for Vendors not registered with ${legalName} and invite them to become new business partners.`
              },
              client: {
                title: 'My Vendors Search',
                helperText: `Search for Vendors registered with ${legalName} by entering the Vendor's business name or trade. To find Vendors near a specific location, you can also enter a service address.`
              }
            };

            this.ChangeDetectorRef.markForCheck();
          }
        });
      }
    });
  }

  CompanyId?: number;
  view?: 'vive' | 'client';

  ViewToTextMap?: {
    vive: { title: string; helperText: string };
    client: { title: string; helperText: string };
  };

  search(SearchModel: ClientVendorSearchModel) {
    const { address } = SearchModel;

    (() => {
      if (address) {
        const { id } = address;
        if (id) {
          return this.GoogleService.addressDetails({ PlaceId: id });
        }
      }

      return from([EMPTY]);
    })().subscribe({
      next: (AddressDetails) => {
        if (AddressDetails) {
          const { location } = AddressDetails;
          if (location) {
            Object.assign(address, { location });
          }
        }

        localStorage.setItem('ClientVendorSearch', JSON.stringify(SearchModel));
        this.router.navigate(['client', this.CompanyId, 'vendors', this.view]);
      }
    });
  }

  // Advanced search currently accepts the SearchModel, but doesn't utilize it for anything.
  advancedSearch(SearchModel: ClientVendorSearchModel) {
    localStorage.removeItem('ClientVendorSearch');
    this.router.navigate(['client', this.CompanyId, 'vendors', this.view]);
  }
}
